module.exports = __webpack_public_path__ + "media/western-wood-pewee-3.3d355178.mp3";